import React, { useState, useEffect } from 'react';

import FURGAPI from '../../services/api.furg';
import { getToken } from '../../services/auth';
import { DocumentoHeader } from './DocumentoHeader';
import MontaFormulario from '../Forms/MontaFormulario';

import { formattedDate, decodeHexHtmlCharCodes } from './../../services/utils';

import { FaAngleDoubleUp } from 'react-icons/fa';
import { Alert } from '../Alert';
import { Loading } from '../Loading';

import { ModalError } from '../ModalError';

const DocumentoFormulario = ({ onUpdate, id, descricao, vestibular, campos, campos_recurso, infoPrimeiraFase = {}, infoRecurso = {}, etapaAtual, pareceres, pareceres_recurso }) => {
    const [camposDF, setCamposDF] = useState(infoPrimeiraFase.campos_defaultValues);
    const [camposDFR, setCamposDFR] = useState(infoRecurso.campos_defaultValues);

    const [infoPF, setInfoPF] = useState(infoPrimeiraFase);
    const [infoR, setInfoR] = useState(infoRecurso);

    const [situacaoGeral, setSituacaoGeral] = useState('warning');
    const [statusFases, setStatusFases] = useState({});
    const [msgErro, setMsgErro] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let statusPrimeiraFase = {};
        let statusRecurso = {};

        setSituacaoGeral('warning');

        let corPrimeiraFase = infoR?.nr_protocolo && infoR?.documentacao_aceita === 'S' ? 'dark' : null;

        if ('N' === infoPF.documentacao_aceita) {
            corPrimeiraFase = corPrimeiraFase ?? 'danger';
            statusPrimeiraFase.alerta = (
                <Alert variant={corPrimeiraFase} icon={false}>
                    {infoPF.nr_protocolo ? (
                        <>
                            <b>Protocolo:</b> {infoPF.nr_protocolo} <br />
                            <b>Data de envio:</b> {formattedDate(infoPF.dt_envio)} <br />
                        </>
                    ) : (
                        <>
                            <b>Protocolo:</b> Não tem protocolo <br />
                        </>
                    )}
                    <b>Avaliação: </b> Documentação indeferida pela comissão avaliadora <br />
                    <b>Parecer: </b> {infoPF.documentacao_parecer}
                    {infoPF.nr_protocolo && <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />}
                </Alert>
            );
        } else if (!infoPF.nr_protocolo) {
            corPrimeiraFase = corPrimeiraFase ?? 'warning';
            statusPrimeiraFase.alerta = (
                <Alert variant={corPrimeiraFase} icon={false}>
                    {infoPF.podeReenviar ? 'Documento sem comprovação ou declaração não finalizada' : 'Você não enviou nenhum documento comprobatório'}
                    <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />
                </Alert>
            );
        } else {
            statusPrimeiraFase.alerta = (
                <Alert variant="success" icon={false}>
                    <b>Protocolo:</b> {infoPF.nr_protocolo} <br />
                    <b>Data de envio:</b> {formattedDate(infoPF.dt_envio)}
                    {'S' === infoPF.documentacao_aceita && (
                        <>
                            <br />
                            <b>Avaliação:</b> Documentação <b>aceita e deferida</b> pela comissão avaliadora
                        </>
                    )}
                    <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />
                </Alert>
            );
            setSituacaoGeral('success');
        }

        if (infoPF.documentacao_aceita === 'N') {
            let variacaoFinal = 'success';
            if ('N' === infoR.documentacao_aceita) {
                variacaoFinal = 'danger';
                statusRecurso.alerta = (
                    <Alert variant={variacaoFinal} icon={false}>
                        {infoR.nr_protocolo ? (
                            <>
                                <b>Protocolo:</b> {infoR.nr_protocolo} <br />
                                <b>Data de envio:</b> {formattedDate(infoR.dt_envio)} <br />
                            </>
                        ) : (
                            <>
                                <b>Protocolo:</b> Não tem protocolo <br />
                            </>
                        )}
                        <b>Avaliação: </b> Documentação indeferida pela comissão avaliadora <br />
                        <b>Parecer: </b> {infoR.documentacao_parecer}
                        {infoR.nr_protocolo && <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />}
                    </Alert>
                );
            } else if (!infoR.nr_protocolo) {
                variacaoFinal = etapaAtual === 'F' ? 'danger' : 'warning';
                statusRecurso.alerta = (
                    <Alert variant={variacaoFinal} icon={false}>
                        {infoR.podeReenviar ? 'Documento sem comprovação ou declaração não finalizada' : 'Você não enviou nenhum documento comprobatório'}
                        <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />
                    </Alert>
                );
            } else {
                statusRecurso.alerta = (
                    <Alert variant={variacaoFinal} icon={false}>
                        <b>Protocolo:</b> {infoR.nr_protocolo} <br />
                        <b>Data de envio:</b> {formattedDate(infoR.dt_envio)}
                        {'S' === infoR.documentacao_aceita && (
                            <>
                                <br />
                                <b>Avaliação:</b> Documentação <b>aceita e deferida</b> pela comissão avaliadora
                            </>
                        )}
                        <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />
                    </Alert>
                );
            }
            setSituacaoGeral(variacaoFinal);
        }

        setStatusFases({
            primeiraFase: statusPrimeiraFase,
            recurso: statusRecurso,
        });
    }, [etapaAtual, infoPF, infoR]);

    const onSubmit = data => {
        setMsgErro('');
        setLoading(true);
        FURGAPI.call('sischamamentos/Publico/gerarProtocoloEnvio', {
            token: getToken(vestibular),
            id_tipo_documento_candidato: id,
            campos: data,
        })
            .then(res => {
                if (etapaAtual === 'N') {
                    if (res.campos_defaultValues) setCamposDF(res.campos_defaultValues);
                    setInfoPF(estadoAtual => (estadoAtual = { ...estadoAtual, ...{ nr_protocolo: res.nr_protocolo, dt_envio: res.dt_envio } }));
                    onUpdate(id, { nr_protocolo: res.nr_protocolo, dt_envio: res.dt_envio });
                } else if ('R' === etapaAtual) {
                    if (res.campos_defaultValues) setCamposDFR(res.campos_defaultValues);
                    setInfoR(estadoAtual => (estadoAtual = { ...estadoAtual, ...{ nr_protocolo: res.nr_protocolo, dt_envio: res.dt_envio } }));
                    onUpdate(id, { nr_protocolo_recurso: res.nr_protocolo, dt_envio_recurso: res.dt_envio });
                }
                setLoading(false);
            })
            .catch(error => {
                setMsgErro(decodeHexHtmlCharCodes(error));
                setLoading(false);
            });
    };

    const onReenviarInformacoes = () => {
        if ('N' === etapaAtual) {
            setInfoPF(estadoAtual => (estadoAtual = { ...estadoAtual, ...{ nr_protocolo: null, dt_envio: null } }));
            setCamposDF({});
        } else if ('R' === etapaAtual) {
            setInfoR(estadoAtual => (estadoAtual = { ...estadoAtual, ...{ nr_protocolo: null, dt_envio: null } }));
            setCamposDFR({});
        }
    };

    return (
        <div className="row">
            <div className="d-flex col-12">
                <div className="flex-fill w-100 card">
                    <div className="card-header card-header--alert">
                        <DocumentoHeader type={situacaoGeral}>{descricao}</DocumentoHeader>
                    </div>
                    {!!statusFases.primeiraFase && (
                        <div className="card-body text-center">
                            {loading && <Loading />}
                            {msgErro && <ModalError onClose={() => setMsgErro('')}>{msgErro}</ModalError>}
                            {/* {AN N AR R F} */}
                            <h2>Primeira fase</h2>
                            {etapaAtual === 'AN' && <MontaFormulario id={`${id}_N`} campos={campos} campos_defaultValues={camposDF} podeReenviar={false} jaEnviado={false} onSubmit={onSubmit} />}
                            {etapaAtual === 'N' && !infoPF.nr_protocolo && (
                                <MontaFormulario
                                    id={`${id}_N`}
                                    campos={campos}
                                    campos_defaultValues={camposDF}
                                    podeReenviar={true}
                                    jaEnviado={false}
                                    onSubmit={onSubmit}
                                    onReenviarInformacoes={onReenviarInformacoes}
                                    pareceres={pareceres}
                                />
                            )}
                            {((etapaAtual === 'N' && infoPF.nr_protocolo) || etapaAtual === 'AR' || etapaAtual === 'R' || etapaAtual === 'F') && (
                                <FaseDocumento
                                    id={`${id}_N`}
                                    campos={campos}
                                    campos_defaultValues={camposDF}
                                    statusFases={statusFases}
                                    infoFase={infoPF}
                                    etapa={'N'}
                                    onSubmit={onSubmit}
                                    onReenviarInformacoes={onReenviarInformacoes}
                                    pareceres={pareceres}
                                />
                            )}
                            {infoPF.documentacao_aceita === 'S' ? (
                                <></>
                            ) : (
                                <>
                                    {!['AN', 'N', 'AR'].includes(etapaAtual) && <h2>Complementação da documentação</h2>}
                                    {etapaAtual === 'R' && !infoR.nr_protocolo && (
                                        <MontaFormulario id={`${id}_R`} campos={campos_recurso} campos_defaultValues={camposDFR} podeReenviar={true} jaEnviado={false} onSubmit={onSubmit} />
                                    )}

                                    {etapaAtual === 'R' && infoR.nr_protocolo && (
                                        <FaseDocumento
                                            id={`${id}_R`}
                                            campos={campos_recurso}
                                            campos_defaultValues={camposDFR}
                                            statusFases={statusFases}
                                            infoFase={infoR}
                                            etapa={'R'}
                                            podeReenviar={true}
                                            jaEnviado={true}
                                            onSubmit={onSubmit}
                                            onReenviarInformacoes={onReenviarInformacoes}
                                        />
                                    )}

                                    {etapaAtual === 'F' && (
                                        <FaseDocumento
                                            id={`${id}_R`}
                                            campos={campos_recurso}
                                            campos_defaultValues={camposDFR}
                                            statusFases={statusFases}
                                            infoFase={infoR}
                                            etapa={'R'}
                                            podeReenviar={false}
                                            jaEnviado={true}
                                            pareceres={pareceres_recurso}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const FaseDocumento = ({ id, campos, campos_defaultValues, onReenviarInformacoes, statusFases, infoFase, etapa, pareceres }) => {
    return (
        <>
            <div className={'accordion accordion--alert collapsed'} data-toggle="collapse" data-target={'#doc_' + id} aria-expanded="true" aria-controls="collapse">
                {etapa === 'N' ? statusFases.primeiraFase.alerta : statusFases.recurso.alerta}
            </div>

            <div id={'doc_' + id} className={'accordion-body collapse '} aria-labelledby="headingOne">
                <MontaFormulario
                    id={id}
                    campos={campos}
                    campos_defaultValues={campos_defaultValues}
                    podeReenviar={infoFase.podeReenviar}
                    jaEnviado={infoFase.nr_protocolo ? true : false}
                    onReenviarInformacoes={onReenviarInformacoes}
                    pareceres={pareceres}
                />
            </div>
        </>
    );
};

export default DocumentoFormulario;
